// extracted by mini-css-extract-plugin
module.exports = {"root":"rich_text-module--root--15Sk5"};